import React, { useContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import recipesContext from '../context/recipesContext';
import searchIcon from '../images/searchIcon.svg';

function SearchButton() {
  const [searchDisabled, setSearchDisabled] = useState(true);
  const { buttonSearch } = useContext(recipesContext);
  const history = useHistory();

  const visibleSearchButton = () => {
    const { location: { pathname } } = history;
    if (pathname.includes('/explore/foods/nationalities')) {
      setSearchDisabled(true);
    } else if (
      pathname.includes('/explore')
      || (pathname.includes('/profile'))
      || (pathname.includes('recipes'))) {
      setSearchDisabled(false);
    } else { setSearchDisabled(true); }
  };

  useEffect(() => {
    visibleSearchButton();
  }, []);

  return (
    <div className="SearchButton">
      {searchDisabled
      && (
        <button
          className="header-search-button"
          type="button"
          onClick={ buttonSearch }
        >
          <img
            className="header-search-img"
            src={ searchIcon }
            data-testid="search-top-btn"
            alt="Search"
          />
        </button>)}
    </div>
  );
}

export default SearchButton;
